import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EstadisticasService } from './../../shared/estadisticas.service';
import { AuthService } from './../../shared/auth/auth.service';
import { Component, OnInit, DoCheck, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy, DoCheck {
  public subscriptions: Subscription[] = [];
  public userIsAuthenticated = false;
  public userRole = 'basic';
  public userID = '';
  public estadisticas: any;
  public noUbicadosURL = '';
  public frasesURL = '';
  public meses = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  constructor(
    private authService: AuthService,
    private estadisticasService: EstadisticasService
  ) {
    this.noUbicadosURL =
      environment.apiURL + '/estadisticas/platos-no-ubicados';
    this.frasesURL = environment.apiURL + '/estadisticas/frases';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];
    this.subscriptions.push(
      this.estadisticasService.get().subscribe((response) => {
        console.log('Estadísticas: ', response);
        this.estadisticas = response[0] ? response[0] : null;
      })
    );
  }

  ngDoCheck(): void {
    window.scroll(0, 0);
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.userRole = this.authService.getUserRole();
    this.userID = this.authService.getUserID();
  }

  getNoUbicados(): void {
    console.log('this.noUbicadosURL : ', this.noUbicadosURL);
    location.replace(this.noUbicadosURL);
  }
}
